import HttpClient from "./HttpClient";

export const RefabricProURL = new HttpClient((process.env.REACT_APP_API_URL as string) + "/" + (process.env.REACT_APP_API_VERSION as string));

/**
 * The canvas API: canvas projects, their comments and their live room (ticket, seed, room WebSocket). Its
 * own base so a build can point the canvas at another API than the rest of the app (local: the v3 API on :8020 while
 * the app talks to stage, `REACT_APP_CANVAS_API_URL`); unset, it IS the app API client.
 */
export const canvasApiBase = (): string => `${process.env.REACT_APP_CANVAS_API_URL || process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}`;

const separateCanvasApi = !!process.env.REACT_APP_CANVAS_API_URL && process.env.REACT_APP_CANVAS_API_URL !== process.env.REACT_APP_API_URL;

export const CanvasApiURL = separateCanvasApi ? new HttpClient(canvasApiBase()) : RefabricProURL;

if (separateCanvasApi) {
  // the session's token is set on the app client (login, refresh, impersonation): the canvas client follows it
  const setAppToken = RefabricProURL.setAuthToken.bind(RefabricProURL);
  RefabricProURL.setAuthToken = (token: string | null) => {
    setAppToken(token);
    CanvasApiURL.setAuthToken(token);
  };
}
